import React, { useEffect, useRef, useState } from "react";
import { getDoctorQueueDisplay } from "../../../../../api/queueApi";
import { io } from "socket.io-client";
import { Grow } from "@material-ui/core";
import { parseJsonStr } from "../../../../../utils/formatHelper";

const initialDoctorQueue = {
    queueWait: [],
    queueInRoom: {},
    queueHold: [],
    doctorInRoom: {},
    queueWaitPage: 1,
    queueWaitPerPage: 4,
    queueHoldPage: 1,
    queueHoldPerPage: 4,
    totalQueueWait: 0,
    totalQueueHold: 0,
};

export default function RoomDetails({
    valueZoom,
    nodeId = 0,
    roomObj = {},
    show = false,
    setSpeakTextQueue = () => {},
}) {
    // ref
    const controllerRef = useRef(null);

    // component state
    const [doctorQueue, setDoctorQueue] = useState(initialDoctorQueue);

    // fetch doctor queue display
    const fetchDoctorQueueDisplay = async (roomId, socketResult) => {
        try {
            const queryParams = {
                roomId,
                queueWaitPage: doctorQueue.queueWaitPage,
                queueWaitPerPage: doctorQueue.queueWaitPerPage,
                queueHoldPage: doctorQueue.queueHoldPage,
                queueHoldPerPage: doctorQueue.queueHoldPerPage,
            };
            let res = null;
            if (!socketResult) {
                res = await getDoctorQueueDisplay(queryParams, controllerRef.current?.signal);
            } else {
                res = socketResult?.data || socketResult;
            }
            if (res) {
                setDoctorQueue(currentState => ({
                    ...currentState,
                    queueWait: res?.patientWait || [],
                    queueHold: res?.patientHold || [],
                    queueInRoom: res?.patientInRoom || {},
                    totalQueueWait: res?.totalQueueWait || 0,
                    totalQueueHold: res?.totalQueueHold || 0,
                    doctorInRoom: res?.doctorInRoom || {},
                }));
                return res;
            }
            return {};
        } catch (error) {
            console.dir(error);
        }
    };

    const fetchQueueWithVoice = async socketData => {
        const roomQueueRes = await fetchDoctorQueueDisplay(roomObj?.roomId, socketData);
        if (roomQueueRes?.patientInRoom?.QueueNo && roomObj?.name) {
            const queueNumber = roomQueueRes?.patientInRoom?.QueueNo?.split("")?.join(" ") || "";
            const roomNameTH = roomObj?.name || "";
            const roomNameEN = roomObj?.nameEn || "";
            setSpeakTextQueue(currentState => [
                ...currentState,
                {
                    text:
                        roomQueueRes?.patientInRoom?.Lang === "en"
                            ? `Queue Number ${queueNumber} Please go to ${roomNameEN}`
                            : `ขอเชิญหมายเลข  ${queueNumber}   ที่${roomNameTH}ครับ`,
                    lang: roomQueueRes?.patientInRoom?.Lang || "th",
                },
            ]);
        }
    };

    const fetchQueueWithoutVoice = async socketData => {
        await fetchDoctorQueueDisplay(roomObj?.roomId, socketData);
    };

    // connect socket.io
    useEffect(() => {
        let socket;
        if (roomObj?.roomId) {
            socket = io(`${process.env?.REACT_APP_HOST_SOCKET}/doctor-queue`, {
                transports: ["websocket"],
            });

            socket.on("connect", () => {
                socket.emit("join-doctor-room", roomObj?.roomId);
            });

            // old -
            // socket.on("doctor-queue-from-update", type => {
            //     if (type === "without-voice") {
            //         fetchQueueWithoutVoice();
            //         return;
            //     }
            //     fetchQueueWithVoice();
            // });

            // new -
            socket.on("doctor-queue-from-update", data => {
                const socketDataObj = parseJsonStr(data);
                if (socketDataObj?.type === "without-voice") {
                    fetchQueueWithoutVoice(socketDataObj);
                    return;
                }
                fetchQueueWithVoice(socketDataObj);
            });

            // old -
            // socket.on("doctor-queue-from-hch", data => {
            //     fetchQueueWithoutVoice();
            // });

            // new -
            socket.on("doctor-queue-from-hch", data => {
                const socketDataObj = parseJsonStr(data);
                if (socketDataObj?.data) {
                    fetchQueueWithoutVoice(socketDataObj);
                }
                if (socketDataObj?.doctorQueueData && Array.isArray(socketDataObj?.doctorQueueData)) {
                    const findDataByRoomId = socketDataObj?.doctorQueueData?.find(
                        data => data?.roomId == roomObj?.roomId, // eslint-disable-line eqeqeq
                    );
                    if (findDataByRoomId) {
                        fetchQueueWithoutVoice(findDataByRoomId);
                    }
                }
            });
        }

        return () => {
            if (roomObj?.roomId && socket) {
                socket.off("connect");
                socket.off("doctor-queue-from-update");
                socket.off("doctor-queue-from-hch");
                socket.emit("leave-doctor-room");
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [roomObj.roomId]);

    useEffect(() => {
        controllerRef.current = new AbortController();
        const init = async () => {
            await fetchQueueWithoutVoice();
        };
        init();
        // to avoid memory leaked.
        return () => {
            controllerRef.current.abort();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <Grow in timeout={{ enter: 600 }}>
            <div className="h-100 d-flex flex-fill flex-column">
                {/* box title queue */}
                <div className="overflow-hidden flex-grow-0 d-flex flex-column">
                    <div className="flex-fill title-rooms rounded-display shadow-sm">
                        <div className="text-center text-2xl font-weight-boldest" style={{ lineHeight: "inherit" }}>
                            {`${roomObj?.name || "-"} / ${roomObj?.nameEn || "-"}`}
                        </div>
                    </div>
                    <div className="flex-fill title-doctor rounded-display shadow-sm">
                        <div className="text-center text-xl font-weight-boldest" style={{ lineHeight: "inherit" }}>
                            {`${doctorQueue?.doctorInRoom?.Doctor?.Doctorname || "-"} / ${doctorQueue?.doctorInRoom
                                ?.Doctor?.DoctorNameEnglish || "-"}`}
                        </div>
                    </div>

                    <div className="flex-fill title-currentQ rounded-display shadow-sm">
                        <div
                            className="text-center text-4xl"
                            style={{ lineHeight: "inherit", fontFamily: "Kanit-Bold", fontWeight: "1000" }}>
                            {doctorQueue?.queueInRoom?.QueueNo || "-"}
                        </div>
                    </div>
                </div>
                {/* box List queue */}
                <div style={{ height: "0%" }} className="flex-fill overflow-auto">
                    <div className="row h-100 m-0 g-0">
                        <div className="h-100 col p-0 pr-2 border-color-r-primary d-flex flex-column">
                            {/* title */}
                            <div
                                style={{ height: "10%" }}
                                className="boxtitle-queue border border-2 border-dark rounded-display bg-white shadow overflow-hidden">
                                <p className="mb-0 text-xl text-center text-red">
                                    รอผลตรวจ
                                    <span>({doctorQueue?.totalQueueHold})</span>
                                </p>
                            </div>
                            {/* list Q */}
                            <div style={{ height: "90%" }}>
                                {doctorQueue?.queueHold?.map((dt, idx) => {
                                    if (idx > 3) {
                                        return null;
                                    }
                                    return (
                                        <div
                                            key={`listWait_${idx}`}
                                            style={{ height: "calc(99% / 4)", lineHeight: 1, fontFamily: "Kanit-Bold" }}
                                            className="d-flex align-items-center justify-content-center text-3xl text-center text-red">
                                            {dt?.QueueNo}
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                        <div className="h-100 col p-0 pl-2 border-color-l-primary d-flex flex-column">
                            {/* title */}
                            <div
                                style={{ height: "10%" }}
                                className="boxtitle-queue border border-2 border-dark rounded-display bg-white shadow overflow-hidden">
                                <p className="mb-0 text-xl text-center">
                                    รอพบแพทย์
                                    <span>({doctorQueue?.totalQueueWait})</span>
                                </p>
                            </div>
                            {/* list Q */}
                            <div id="FORGET_HIGHT_CONTENT_LIST" style={{ height: "90%" }}>
                                {doctorQueue?.queueWait?.map((dt, idx) => {
                                    if (idx > 3) {
                                        return null;
                                    }
                                    return (
                                        <div
                                            key={`listNow_${idx}`}
                                            style={{ height: "calc(99% / 4)", lineHeight: 1, fontFamily: "Kanit-Bold" }}
                                            className="d-flex align-items-center justify-content-center text-3xl text-center">
                                            {dt?.QueueNo}
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Grow>
    );
}
